<template>

    <div class="legal-wrapper">

        <div class="container">

            <a href="/" class="back-link">
                <i class="fa-solid fa-arrow-left me-2"></i>Zurück zur Startseite
            </a>

            <div class="legal-content">

                <router-view />

            </div>

        </div>

    </div>

    <TheFooterComponent />

</template>

<script>

    import TheFooterComponent from '@/components/TheFooterComponent'

    export default {

        name: 'TheLegalLayout',

        components: {

            TheFooterComponent,

        },

    }

</script>

<style scoped>

    .legal-wrapper {

        min-height: 100vh;
        padding-top: 3rem;
        padding-bottom: 4rem;
        background: #f7fafd;

    }

    .back-link {

        display: inline-block;
        color: #0B5FA5;
        text-decoration: none;
        font-size: 0.88rem;
        margin-bottom: 2rem;
        transition: opacity 0.2s ease;

    }

    .back-link:hover {

        opacity: 0.75;

    }

    .legal-content {

        background: #fff;
        border: 1px solid #e4edf5;
        border-radius: 8px;
        padding: 2.5rem;
        max-width: 820px;

    }

</style>
